<ion-list>
  <div *ngFor="let element of elements" (click)="selectElement(element)">
    <span>{{ element.label }}</span>
    <ion-icon *ngIf="element.isSelected" name="checkmark"></ion-icon>
  </div>
</ion-list>
